import { useEffect, useState, useRef } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import api, { formatCLP } from "@/lib/api";
import { useCart } from "@/context/CartContext";
import { Button } from "@/components/ui/button";
import { CheckCircle, XCircle, CircleNotch } from "@phosphor-icons/react";

export default function PaymentReturn() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { refresh } = useCart();
  const [state, setState] = useState("processing"); // processing | success | failed | aborted
  const [order, setOrder] = useState(null);
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    const token = params.get("token_ws");
    const status = params.get("status");
    if (status === "error") { setState("failed"); return; }
    if (status === "aborted" || !token || token === "null" || token === "None") { setState("aborted"); return; }
    api.post("/checkout/webpay/commit", { token })
      .then(({ data }) => {
        setOrder(data);
        setState(data.status === "paid" ? "success" : "failed");
        refresh();
      })
      .catch(() => setState("failed"));
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-6">
      <div className="w-full max-w-md text-center bg-white border border-border rounded-lg p-10 animate-fade-up" data-testid="payment-return">
        {state === "processing" && (<><CircleNotch size={56} className="animate-spin text-primary mx-auto mb-5" /><h1 className="font-display text-2xl font-800 tracking-tight">Confirmando tu pago…</h1><p className="text-muted-foreground mt-2">Estamos validando la transacción con Webpay.</p></>)}
        {state === "success" && (<><CheckCircle size={64} weight="fill" className="text-primary mx-auto mb-5" /><h1 className="font-display text-3xl font-800 tracking-tight">¡Pago aprobado!</h1><p className="text-muted-foreground mt-2">Orden {order?.id?.slice(0, 8).toUpperCase()} · {formatCLP(order?.total)}. Ya tienes acceso a tus cursos.</p><div className="flex gap-3 justify-center mt-7"><Button onClick={() => navigate("/dashboard/cursos")} className="bg-primary text-white hover:bg-blue-600" data-testid="pr-go-courses">Ir a Mis Cursos</Button></div></>)}
        {state === "failed" && (<><XCircle size={64} weight="fill" className="text-destructive mx-auto mb-5" /><h1 className="font-display text-2xl font-800 tracking-tight">El pago no se completó</h1><p className="text-muted-foreground mt-2">La transacción fue rechazada o no pudo confirmarse.</p><Button onClick={() => navigate("/carrito")} variant="outline" className="mt-7">Volver al carrito</Button></>)}
        {state === "aborted" && (<><XCircle size={64} className="text-muted-foreground mx-auto mb-5" /><h1 className="font-display text-2xl font-800 tracking-tight">Pago cancelado</h1><p className="text-muted-foreground mt-2">Cancelaste el proceso de pago.</p><Button onClick={() => navigate("/carrito")} variant="outline" className="mt-7">Volver al carrito</Button></>)}
      </div>
    </div>
  );
}
